import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { AuthenticationGuard } from './authentication.guard';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full'  },
  { path: 'admin', loadChildren: () => import('./modules/admin/admin.module').then((m) => m.AdminModule), canActivate: [AuthenticationGuard], data: { roles: [ "Admin", "SystemUser"] }},
  { path: 'provider', loadChildren: () => import('./modules/provider/provider.module').then((m) => m.ProviderModule), canActivate: [AuthenticationGuard], data: { roles: [ "Provider", "Consultant", "ProviderReadOnly"] } },
  { path: 'lender', loadChildren: () => import('./modules/lender/lender.module').then((m) => m.LenderModule), canActivate: [AuthenticationGuard], data: { roles: [ "Lender", "LenderReadOnly"] }  },
  { path: 'access-denied', component: AccessDeniedComponent },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
